<div class="search-container">
  <div class="row">
    <div class="col-md-12 col-sm-12 default-text show-hide-link">
      <a (click)="showHideSearchbar($event)">{{'group_details.search_bar.show_hide' | translate}}</a>
    </div>
    <div class="col-md-12 col-sm-12">
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <div class="d-flex flex-row flex-nowrap">
            <div class="d-flex flex-auto align-items-center">
              <div class="seperate-line"></div>
            </div>
            <div class="d-flex align-items-center">
              <a *ngIf="showSearchBar" class="filter-btn" (click)="clearFilter()">{{'group_details.search_bar.clear_filter' | translate}}</a>
              <a *ngIf="!showSearchBar" class="filter-btn" (click)="showHideSearchbar($event)">{{'group_details.search_bar.open_filter' | translate}}</a>
            </div>
          </div>
        </div>
        <div *ngIf="showSearchBar" class="col-md-12 col-sm-12 mt-3">
          <div class="d-flex flex-row flex-auto measure-filter-option-container">
            <div class="measure-filter-option project">
              <project-selection #projectSelection  [options]="projectList"
                                  name="searchByProject"
                                  [(model)]="measureSearchCriteria.project_id"
                                  placeholder="{{'measure.filters.project_placeholder' | translate}}"
                                  (selectEvent)="generateReport($event, 'project_id', 'Project')"
                                  [actionData]="projectDataForSegment"
                                  (afterDeleteProjectEvent)="afterDeleteProjectCallback($event)"
                                  (editProjectEvent)="onEditOrCreateProject($event)"
                                  (openDropDownEvent)="closeTooltipManually(tpro)"
                                  #tpro="ngbTooltip"
                                  placement="bottom"
                                  ngbTooltip="{{'info_box.measure.project_filter' | translate}}"
                                  [tooltipBox]="tpro">
              </project-selection>
            </div>
            <ng-template ngxPermissionsOnly="menu.enable_groups">
              <div class="measure-filter-option">
                <achoo-filter-box [options]="influencerGroupList"
                                  name="searchByGroup"
                                  actionByLevels="Standard Reports (Performance, Exposure, Segmentation, ROI)"
                                  [wallName]="'Reports Disabled'"
                                  [(model)]="measureSearchCriteria.influencerGroup"
                                  placeholder="{{'measure.filters.influencer_group_placeholder' | translate}}"
                                  (selectEvent)="generateReport($event, 'influencerGroup', 'Influencer Group')"
                                  (openDropDownEvent)="closeTooltipManually(tg)"
                                  #tg="ngbTooltip"
                                  placement="bottom"
                                  ngbTooltip="{{'info_box.measure.group_filter' | translate}}"
                                  [tooltipBox]="tg">
                </achoo-filter-box>
              </div>
            </ng-template>
            <ng-template ngxPermissionsOnly="menu.enable_campaigns">
              <div class="measure-filter-option">
                <achoo-filter-box [options]="campaignList"
                                  name="searchByCampaign"
                                  actionByLevels="Standard Reports (Performance, Exposure, Segmentation, ROI)"
                                  [wallName]="'Reports Disabled'"
                                  [(model)]="measureSearchCriteria.campaign_id"
                                  placeholder="{{'measure.filters.campaign_placeholder' | translate}}"
                                  (selectEvent)="generateReport($event, 'campaign_id', 'Campaign')"
                                  (openDropDownEvent)="closeTooltipManually(tc)"
                                  #tc="ngbTooltip"
                                  placement="bottom"
                                  ngbTooltip="{{'info_box.measure.campaign_filter' | translate}}"
                                  [tooltipBox]="tc">
                </achoo-filter-box>
              </div>
            </ng-template>
            <!--
            TODO: Enable this when the backend supports it
            REVIEW: Do we have a better way to deal with this than commented code? :)
            <div class="measure-filter-option">
              <achoo-filter-box [options]="platFormList"
                                name="searchByChannel"
                                [(model)]="measureSearchCriteria.channel"
                                placeholder="{{'measure.filters.platform_placeholder' | translate}}"
                                (selectEvent)="generateReport($event, 'Platform')">
              </achoo-filter-box>
            </div>
            <div class="measure-filter-option">
              <achoo-filter-box [options]="countryList"
                                name="searchByCountry"
                                [(model)]="measureSearchCriteria.country_id"
                                placeholder="{{'measure.filters.country_placeholder' | translate}}"
                                (selectEvent)="generateReport($event, 'Country')">
              </achoo-filter-box>
            </div>
            -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/measure/measure-filter/measure-filter.component.html